var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavedLoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 3.33398V6.66732H6.66659V3.33398M4.99992 3.33398H13.3333L16.6666 6.66732V15.0007C16.6666 15.4427 16.491 15.8666 16.1784 16.1792C15.8659 16.4917 15.4419 16.6673 14.9999 16.6673H4.99992C4.55789 16.6673 4.13397 16.4917 3.82141 16.1792C3.50885 15.8666 3.33325 15.4427 3.33325 15.0007V5.00065C3.33325 4.55862 3.50885 4.1347 3.82141 3.82214C4.13397 3.50958 4.55789 3.33398 4.99992 3.33398ZM8.33325 11.6673C8.33325 12.1093 8.50885 12.5333 8.82141 12.8458C9.13397 13.1584 9.55789 13.334 9.99992 13.334C10.4419 13.334 10.8659 13.1584 11.1784 12.8458C11.491 12.5333 11.6666 12.1093 11.6666 11.6673C11.6666 11.2253 11.491 10.8014 11.1784 10.4888C10.8659 10.1762 10.4419 10.0007 9.99992 10.0007C9.55789 10.0007 9.13397 10.1762 8.82141 10.4888C8.50885 10.8014 8.33325 11.2253 8.33325 11.6673Z",
    stroke: "#017BFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedLoad);
export default __webpack_public_path__ + "static/media/saved-load.a2d93ac33cce8f3a64a5ef79da07ab8f.svg";
export { ForwardRef as ReactComponent };